






















import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator';
import { Scope } from 'spraypaint';
import { ApplicationRecord } from '@/api';

@Component({
  components: {},
})
export default class extends Vue {
  @Prop({ default: '' })
  readonly label: string;

  @Prop({ default: '' })
  readonly placeholder: string;

  @Prop({ default: 'name' })
  readonly itemText: string;

  @Prop({ default: 'id' })
  readonly itemValue: string;

  @Prop({})
  readonly noDataText: string;

  @Prop({ default: false })
  readonly dark: boolean;

  @Prop({ default: false })
  readonly filled: boolean;

  @Prop({ default: false })
  readonly dense: boolean;

  @Prop({ default: false })
  readonly clearable: boolean;

  @Prop({ required: false })
  readonly rules: any;

  @Prop({ required: true })
  readonly scopeFactory: () => Scope<ApplicationRecord>;

  @Prop({})
  readonly scopeWhere: any;

  @Prop({})
  readonly defaultValue: string;

  @Model('input', { type: ApplicationRecord })
  readonly value: ApplicationRecord;

  get selected() {
    return this.value;
  }

  set selected(d) {
    if (d) {
      this.$emit('input', d);
    } else {
      this.$emit('input', null);
    }
  }

  loading: boolean = false;

  search: string = '';

  items: ApplicationRecord[] = [];

  clear(e: Event) {
    this.$emit('click:clear', e);
  }

  change(e: Event) {
    this.$emit('change', e);
  }

  async update(forceUpdate = false, defaultVal: string = '') {
    try {
      this.loading = true;
      const scope = this.scopeFactory().where(this.scopeWhere);
      const result = await scope.all();
      this.items = result.data;

      if (forceUpdate && defaultVal) {
        const item = this.items.find(element => {
          return defaultVal === element.id;
        });

        if (item) {
          this.selected = item;
        }
      } else if (forceUpdate && this.selected) {
        const item = this.items.find(element => {
          return this.selected.id === element.id;
        });

        if (item) {
          this.selected = item;
        }
      }
    } catch (e) {
      this.items = [];
    } finally {
      this.loading = false;
    }
  }

  mounted() {
    this.update(true, this.defaultValue);
  }

  @Watch('scopeWhere')
  scopeChanged() {
    this.update();
  }
}
